import { $lang } from '@msdk/common'
import {
  EMPTY_CELL_VALUE,
  FieldValue,
  getConversionUM,
  NumericFieldDefinition,
  NumericValue,
  ViewColumnDefinition,
} from '@msdk/definitions'
import { Link, Typography } from '@msdk/ui'
import React from 'react'
import { useRecoilValue } from 'recoil'

import { getFieldDefIncludeExternal } from '../../../utils'
import { useDynamicViewContext } from '../context'
import { Ellipsis } from './utils'

interface Props {
  clickable?: boolean
  onItemClick?: () => void
  value: FieldValue<unknown> | null
  ellipsis: boolean
  colDef: ViewColumnDefinition
}

export function NumericCellRenderer({ clickable, onItemClick, value, ellipsis, colDef }: Props) {
  const lang = useRecoilValue($lang)
  const TypographyComponent = ellipsis ? Ellipsis : Typography

  const { baseMetadata, viewModel } = useDynamicViewContext()
  const fieldDef = getFieldDefIncludeExternal(viewModel, colDef.fieldName, baseMetadata) as NumericFieldDefinition
  const typedValue = value as NumericValue

  const displayUm = fieldDef.customMeasurementUnit
    ? typedValue?.um
    : typedValue?.um || getConversionUM(fieldDef.um, fieldDef.entityName, fieldDef.name) || fieldDef.um

  const displayValue = typedValue?.value
  const numericDisplay = new NumericValue(displayValue, displayUm, typedValue?.approximation, typedValue?.decimalLimit)
  const hasValue = displayValue !== null && displayValue !== undefined

  if (hasValue && clickable) {
    return (
      <TypographyComponent variant="body1">
        <Link underline="hover" onClick={onItemClick}>
          {numericDisplay.toStringForView(lang, displayUm)}
        </Link>
      </TypographyComponent>
    )
  }

  return (
    <TypographyComponent variant="body1">
      {hasValue ? numericDisplay.toStringForView(lang, displayUm) : EMPTY_CELL_VALUE}
    </TypographyComponent>
  )
}
